import { useTranslation } from '@frontend/i18n';
import { PanelContent, PanelPortal, PanelHeader } from '@frontend/panel-engine';
import { useBreakpoint } from '@frontend/responsiveness';
import { ModalControlModalProps, Tray, Heading, Button, useThemeValues } from '@frontend/design-system';
import { writebackModalTrackingIds } from '../../tracking-ids';
import { WriteBack } from './write-back'; // Assumes you have this component

const WritebackSidePanelDesktopView = ({ onClose }: ModalControlModalProps) => {
  const { t } = useTranslation('insuranceDetails');

  return (
    //TODOL: Update the id to weave-writeback-status ones you get panel priority from payge
    <PanelPortal id='weave-insurance-verification' width='smallXL' onClose={onClose} enableAnimations>
      <PanelHeader>
        <PanelHeader.Title level={2}>{t('Writeback Status')}</PanelHeader.Title>
        <PanelHeader.Close trackingId={writebackModalTrackingIds.closeWritebackModalContainerButton} />
      </PanelHeader>
      <PanelContent css={{ height: '100%' }}>
        <WriteBack onClose={onClose} />
      </PanelContent>
    </PanelPortal>
  );
};

const WritebackSideTrayMobileView = ({ ...modalProps }: ModalControlModalProps) => {
  const { t } = useTranslation('insuranceDetails');
  const theme = useThemeValues();

  return (
    <Tray {...modalProps} width='smallXL' css={{ padding: '0' }} disableCloseOnEscape>
      <Tray.Header
        css={{ alignItems: 'flex-start', padding: theme.spacing(2) }}
        Buttons={<Button iconName='x' variant='secondary' label='close' onClick={modalProps.onClose} />}
      >
        <Heading level={2}>{t('Writeback Status')}</Heading>
      </Tray.Header>
      <Tray.Body css={{ padding: theme.spacing(0, 4, 4, 4), height: '100%' }}>
        <WriteBack onClose={modalProps.onClose} />
      </Tray.Body>
    </Tray>
  );
};

export const WritebackSidePanel = ({ ...modalProps }: ModalControlModalProps) => {
  const size = useBreakpoint();
  const isDesktop = size === 'large' || size === 'xlarge';

  /**
   * When openModal is triggered from useModalControl then modalProps.show is set to true and sidePanel is displayed.
   * When onClose is triggered from useModalControl then modalProps.show is set to false and sidepanel is not displayed.
   */
  if (!modalProps.show) {
    return null;
  }

  return isDesktop ? (
    <WritebackSidePanelDesktopView {...modalProps} />
  ) : (
    <WritebackSideTrayMobileView {...modalProps} />
  );
};
